import React, { useState, useRef, useEffect } from "react";
import Badge from "react-bootstrap/Badge";
import FormControl from "react-bootstrap/FormControl";
import Spinner from "react-bootstrap/Spinner";
import auth from "../../../Account/Auth";
import be from "../../../BE";

const componentStyle = {
  fontSize: 20,
  fontWeight: 300,
  whiteSpace: "nowrap",
  maxWidth: "100%",
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const pillStyle = {
  fontSize: "0.7em",
};

export default function EditableGuest({
  id,
  name: initialName,
  amount,
  currency,
  pendingReason,
  action,
  onNameUpdated,
}) {
  const [name, setName] = useState(initialName);
  const [editing, setEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const inputRef = useRef(null);

  // Sync local state if prop changes
  useEffect(() => {
    setName(initialName);
  }, [initialName]);
  
  const saveName = async () => {
    setIsSaving(true);
    try {
      await auth.isAuthenticated();
      await be.patch(
        "jubilant-booking",
        `/booking/${id}/guests`,
        { name },
        true,
        true
      );
      if (onNameUpdated) onNameUpdated(id, name);
      setEditing(false);
    } catch (error) {
      console.error("[upcomings-guest] error updating guest name:", error);
      // Optionally show user error feedback
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <span style={componentStyle}>
      {/* Inline edit icon on left */}
      {editing ? (
        <span
          style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}
        >
          <FormControl
            ref={inputRef}
            size="sm"
            style={{ maxWidth: "150px", display: "inline-block" }}
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && saveName()}
            disabled={isSaving}
          />
          {isSaving ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <span
              onClick={saveName}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              save
            </span>
          )}
        </span>
      ) : (
        <span
          style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}
        >
          <i
            className="fa-solid fa-pencil"
            style={{ fontSize: "0.6em", cursor: "pointer" }}
            onClick={() => setEditing(true)}
          />
          {name}
        </span>
      )}

      {/* Paid indicator */}
      {amount && currency && <span className="ms-1">💸</span>}

      {/* Pending badge */}
      {action === "on_wait" && pendingReason && (
        <small className="ms-1 d-inline-flex align-middle" style={pillStyle}>
          <Badge pill bg="warning">
            {pendingReason.replaceAll("_", " ")}
          </Badge>
        </small>
      )}
    </span>
  );
}
